import { render, staticRenderFns } from "./addressDetail.vue?vue&type=template&id=983dbfee&scoped=true&"
import script from "./addressDetail.vue?vue&type=script&lang=js&"
export * from "./addressDetail.vue?vue&type=script&lang=js&"
import style0 from "./addressDetail.vue?vue&type=style&index=0&id=983dbfee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983dbfee",
  null
  
)

export default component.exports